// extracted by mini-css-extract-plugin
module.exports = {"PixelDropdown":"SwitchDisplayModeView_PixelDropdown__Fbe6f"};